import React from 'react';

const FleetIcon = () => {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_42_75)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M23.2686 52.1656C23.2686 53.4478 23.771 54.6774 24.6654 55.584C25.5598 56.4907 26.7729 57 28.0378 57C29.3027 57 30.5157 56.4907 31.4101 55.584C32.3045 54.6774 32.807 53.4478 32.807 52.1656C32.807 50.8834 32.3045 49.6538 31.4101 48.7471C30.5157 47.8405 29.3027 47.3312 28.0378 47.3312C26.7729 47.3312 25.5598 47.8405 24.6654 48.7471C23.771 49.6538 23.2686 50.8834 23.2686 52.1656ZM47.1147 52.1656C47.1147 53.4478 47.6172 54.6774 48.5116 55.584C49.406 56.4907 50.6191 57 51.8839 57C53.1488 57 54.3619 56.4907 55.2563 55.584C56.1507 54.6774 56.6532 53.4478 56.6532 52.1656C56.6532 50.8834 56.1507 49.6538 55.2563 48.7471C54.3619 47.8405 53.1488 47.3312 51.8839 47.3312C50.6191 47.3312 49.406 47.8405 48.5116 48.7471C47.6172 49.6538 47.1147 50.8834 47.1147 52.1656Z'
            stroke='#FEFEFE'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M23.0366 51.3827L19 51.3827V25.3652C19 24.7379 19.2458 24.1363 19.6834 23.6928C20.121 23.2492 20.7145 23 21.3333 23H42.3333V51.3827M33 51.3827H47M57.0366 51.3827L61 51.3827V37.1913M61 37.1913H42.3333M61 37.1913L54 25.3652H42.3333'
            stroke='#FEFEFE'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_42_75'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_42_75'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default FleetIcon;
